<template>
  <div
    class="product-box-campaign"
    :class="{
      'product-box-campaign--in-basket': productBoxData.inBasket,
      'product-box-campaign--error': state === 'error',
      'product-box-campaign--red-wine': wineType === 'red',
      'product-box-campaign--rose-wine': wineType === 'rose',
      'product-box-campaign--white-wine': wineType === 'white',
      'product-box-campaign--homogen': setType === 'homogen',
      'product-box-campaign--heterogen': setType === 'heterogen',
      'product-box-campaign--has-quote': productBoxData.flags.quote && productBoxData.flags.quote.text,
      'product-box-campaign--has-quickfacts': hasQuickfacts,
      'product-box-campaign--personalization': productBoxData.personalPreferenceMessageKey,
      'product-box-campaign--no-quote': !initialProductBoxData.flags.quote
    }"
    :data-id="productBoxData.id"
    :data-item-id="productBoxData.itemId"
    :data-artnr="productBoxData.trackingData.artNr"
    :data-wban="productBoxData.trackingData.wban"
  >
    <div
      v-if="productBoxData.price.savedPercentage"
      class="product-box-campaign__savings"
      :class="{
        'flag-savings--bigger': savedAmountBigger
      }"
    >
      <flag-savings
        :second-text-key="'flags.savings.text.savedAmount'"
        :saved-percentage="savedPercentage"
        :saved-amount="savedAmount"
      />
    </div>
    <div class="product-box-campaign__segment-image">
      <div class="product-box-campaign__flags">
        <flags
          :flags="productBoxData.flags"
          :limit="2"
          :award-limit="2"
          :white-list="['new', 'award', 'bio']"
        />
      </div>
      <div class="product-box-campaign__image-background-wrapper">
        <component
          :is="productBoxData.linked ? 'a' : 'div'"
          :href="productBoxData.linked ? productBoxData.url : null"
          class="product-box-campaign__image-wrapper"
        >
          <div
            class="lazy-load-image product-box-campaign__image"
          >
            <image-element
              v-once
              img-class="lazy-load-image__image"
              :src="imgSrc"
              :title="productBoxData.images[0].title"
              :alt="productBoxData.images[0].alt"
              :webp="true"
            />
          </div>
        </component>
      </div>
    </div>
    <div class="product-box-campaign__segment-box">
      <div class="product-box-campaign__segment-center">
        <a
          class="product-box-campaign__header product-box__segment-header"
          :href="productBoxData.url"
        >
          <div class="product-box-campaign__header-text product-box__header-text">
            <div class="product-box-campaign__header-top">
              <span
                class="product-box-campaign__set-name"
                v-if="productBoxData.description1"
                v-html="productBoxData.description1"
              />
              <span
                class="product-box-campaign__set-type"
                v-text="setTypeName"
              />
            </div>
            <div
              class="product-box-campaign__quickfacts-wrapper"
              v-if="hasQuickfacts"
            >
              <quickfacts
                class="product-box-campaign__quickfacts"
                :quickfacts="quickfactList"
                :use-links="false"
              />
            </div>
          </div>
        </a>
        <div class="product-box-campaign__long-description-wrapper">
          <div class="product-box-campaign__quote-block">
            <span
              class="product-box-campaign__title"
              v-if="productBoxData.shortDescription"
              v-html="productBoxData.shortDescription"
            />
            <div
              class="product-box-campaign__long-description"
              v-if="!initialProductBoxData.flags.quote"
              v-html="descriptionExcerpt"
            />
            <div
              class="product-box-campaign__quote-text"
              v-if="initialProductBoxData.flags.quote"
              v-html="initialProductBoxData.flags.quote.text"
            />
            <div
              class="product-box-campaign__quote"
              v-if="initialProductBoxData.flags.quote"
            >
              <div class="product-box-campaign__quote-text-wrapper">
                <div
                  class="product-box-campaign__quote-author"
                  v-if="initialProductBoxData.flags.quote.author"
                  v-html="initialProductBoxData.flags.quote.author"
                />
              </div>
            </div>
          </div>
          <div
            class="product-box-campaign__quote-image-wrapper"
            v-if="initialProductBoxData.flags.quote"
          >
            <lazy-load
              class="product-box-campaign__quote-image"
              v-if="initialProductBoxData.flags.quote.image"
            >
              <image-element
                img-class="lazy-load-image__image"
                :src="[initialProductBoxData.flags.quote.image]"
                :alt="initialProductBoxData.flags.quote.author"
                :webp="true"
              />
            </lazy-load>
          </div>
        </div>
      </div>
      <div
        class="product-box-campaign__segment-conversion"
        v-if="productBoxData.zeroPriceItem"
      >
        <div class="product-box-campaign__price-wrapper product-box-campaign__price-wrapper--no-price">
          <div class="product-box__buttons">
            <a
              class="product-box__status product-box__status--unavailable"
              :href="productBoxData.url"
            >
              {{ $t('availability.no-price') }}
            </a>
          </div>
        </div>
      </div>
      <div class="product-box-campaign__segment-conversion">
        <div class="product-box-campaign__segment-conversion-price">
          <span class="product-box-campaign__bottle-amount">
            <span
              v-if="productBoxData.numberOfBottlesInSet && productBoxData.numberOfBottlesInSet >= 2"
            >
              {{ $t('volumeUnit.numberOfBottlesInSet', [productBoxData.numberOfBottlesInSet]) }}
            </span>
          </span>
          <availability-info
            v-if="showAvailability"
            class="product-box-campaign__availability product-box__availability"
            :availability="productBoxData.availability"
          />
          <price-info
            v-if="productBoxData.price"
            class="product-box-campaign__price product-box__price"
            :value="productBoxData.price"
            :alcohol="productBoxData.alcohol"
            :show-volume-unit-text="true"
            :show-star="true"
          />
        </div>
        <div class="product-box-campaign__segment-conversion-buttons">
          <product-qty-and-cart-btn
            class="product-box-campaign__buttons"
            :product-data="productBoxData"
            :product-link="productLink"
            :state="state"
            @addToBasket="addToBasket"
            @quantityChange="changeQuantity"
            @onRequestClicked="openOnRequestLightBox"
          />
          <a
            class="product-box__status product-box__status--basket"
            v-if="productBoxData.inBasket"
            :href="basketUrl"
          >
            {{ $t('ads.ads_top_info.article_in_basket') }}
          </a>
          <a
            v-if="productBoxData.showFoodSpecificationLink && !hideCounterButton"
            :href="foodSpecificationLink"
            class="product-box__link"
            v-html="$t('detail.product.characteristics')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import ProductBox from '../productBox/productBox.vue';
  import AvailabilityInfo from '../availabilityInfo/availabilityInfo.vue';
  import ProductQtyAndCartBtn from '../productQtyAndCartBtn/productQtyAndCartBtn.vue';
  import Flags from '../flags/flags.vue';
  import FlagSavings from '../flagSavings/flagSavings.vue';
  import ImageElement from '../imageElement/imageElement.vue';
  import LazyLoad from '../lazyLoad/lazyLoad.vue';
  import Quickfacts from '../quickfacts/quickfacts.vue';
  import {excerpt} from '../../utilities/js/excerpt/excerpt';
  import type ProductBoxData from '../../types/ProductBoxData';

  export default {
    name: 'ProductBoxCampaign',
    components: {
      LazyLoad,
      ImageElement,
      AvailabilityInfo,
      ProductQtyAndCartBtn,
      Quickfacts,
      Flags,
      FlagSavings
    },
    mixins: [ProductBox],

    excerptLength: 40,

    data() {
      return {
        initialProductBoxData: this.productBoxData as ProductBoxData,
      }
    },

    computed: {
      wineType() {
        return this.$t('productBoxCampaign.winetype.' + this.initialProductBoxData.setEkwgr);
      },
      setType() {
        return this.initialProductBoxData.heterogenSet ? 'heterogen' : 'homogen';
      },
      setTypeName() {
        return this.$t('productBoxCampaign.typeName.' + this.initialProductBoxData.setEkwgr);
      },
      descriptionExcerpt() {
        if (this.initialProductBoxData.longDescription) {
          return excerpt(this.initialProductBoxData.longDescription, this.excerptLength);
        }
        return '';
      },
      quickfactList() {
        return this.initialProductBoxData.quickfacts.filter((item) => item.type === 'area' || item.type === 'taste' || item.type === 'grapeVariety');
      },
      savedPercentage() {
        return `<span class="minus">-</span><span>${this.productBoxData.price.savedPercentage}</span><span class="percent"></span>`;
      },
      hasQuickfacts() {
        return this.setType === 'homogen' && this.quickfactList && this.quickfactList.length > 0;
      },
      savedAmountBigger() {
        return this.productBoxData.price.savedAmount.toString().indexOf(',00') >= 0;
      },
      savedAmount() {
        return this.productBoxData.price.savedAmount.toString().replace(',00', '');
      },
      imgSrc(): string[] {
        let src = this.productBoxData.images.length > 1
          ? [this.productBoxData.images[0].src.replace(/.jpg/g, '.png'), this.productBoxData.images[1].src.replace(/.jpg/g, '.png')]
          : [this.productBoxData.images[1].src];
        return src;
      }
    }
  }
</script>
